import { Injectable, OnDestroy, inject } from '@angular/core';

import { FsStore } from '@firestitch/store';

import { Observable, Subject, interval, merge, of } from 'rxjs';
import { catchError, startWith, switchMap, takeUntil, takeWhile } from 'rxjs/operators';

import { AccountData } from '@app/core';

@Injectable({
  providedIn: 'root',
})
export class NotificationService implements OnDestroy {
  private accountData = inject(AccountData);
  private _store = inject(FsStore);


  public notification$: Observable<any>;

  private _reloadNotification$ = new Subject<void>();
  private _intervalSeconds = 60;
  private _destroy$ = new Subject<void>();
  private _account;

  constructor() {
    this.notification$ =
      merge(
        interval(this._intervalSeconds * 1000),
        this._reloadNotification$,
      )
        .pipe(
          startWith(0),
          takeWhile(() => {
            return !!this._account;
          }),
          switchMap(() => {
            return this.accountData.notificationsUnread()
              .pipe(
                catchError(() => {
                  return of();
                }),
              );
          }),
        );

    this._store.observe('account')
      .pipe(
        takeUntil(this._destroy$),
      )
      .subscribe((store) => {
        this._account = store.value;
      });
  }

  public reload(): void {
    this.accountData.notificationsUnread()
      .subscribe((unread) => {
        this._reloadNotification$.next(unread);
      });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

}
